import * as React from 'react';

import { Button } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';
import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';
import type { Maybe } from 'bundles/xddp/__generated__/baseContentfulTypes';

import _t from 'i18n!nls/xddp';

import 'css!bundles/xddp/components/__styles__/shared/OpenCourseBanner';

type Props = {
  marketingContent?: Maybe<string>;
  openCourseBannerLink?: Maybe<string>;
  handleShowEoiForm?: any;
  onApplyNowClick?: () => void;
};

const OpenCourseBanner = ({ marketingContent, openCourseBannerLink, handleShowEoiForm, onApplyNowClick }: Props) => {
  const label = openCourseBannerLink ? _t('Get Started') : _t('Request Info');

  return (
    <div className="rc-OpenCourseBanner">
      {marketingContent && <Markdown className="description" source={marketingContent} />}

      <Button
        variant="primary"
        trackingName="get_started"
        component={TrackedLink2}
        withVisibilityTracking={true}
        requireFullyVisible={true}
        href={openCourseBannerLink && openCourseBannerLink}
        target="_blank"
        onClick={openCourseBannerLink ? onApplyNowClick : handleShowEoiForm}
      >
        {label}
      </Button>
    </div>
  );
};

export default OpenCourseBanner;
